import { render, staticRenderFns } from "./DocToast.vue?vue&type=template&id=4f74fca1&scoped=true&"
import script from "./DocToast.vue?vue&type=script&lang=js&"
export * from "./DocToast.vue?vue&type=script&lang=js&"
import style0 from "./DocToast.vue?vue&type=style&index=0&id=4f74fca1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f74fca1",
  null
  
)

export default component.exports